import gql from "graphql-tag";

const UpsertUserProjectViewMutation = gql`
  mutation UpsertUserProjectView($projectId: uuid!) {
    insert_userProjectView_one(
      object: { projectId: $projectId, viewedAt: "now()" }
      on_conflict: { constraint: user_project_view_pkey, update_columns: [viewedAt] }
    ) {
      projectId
      viewedAt
    }
  }
`;

export default UpsertUserProjectViewMutation;
